module.exports = __webpack_public_path__ + "img/icon-success.1b13a254.png";